import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isSameDay from 'date-fns/is_same_day';
import Calendar from "../Calendar";
import DateInput from "../DateInput";
import { getMobileOS } from "../../utils/detect-mobile";
import CalendarIcon from "./assets/calendarIcon.svg";
import cx from "./utils/styles";
var isNative = getMobileOS();
var emptyCb = function emptyCb() {
  return undefined;
};
export var DatePickerStateless = /*#__PURE__*/function (_Component) {
  _inherits(DatePickerStateless, _Component);
  var _super = _createSuper(DatePickerStateless);
  function DatePickerStateless(props) {
    var _this;
    _classCallCheck(this, DatePickerStateless);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      return _this.removeClickListeners();
    });
    _defineProperty(_assertThisInitialized(_this), "addClickListeners", function () {
      document.addEventListener('click', _this.handleOutsideClick, false);
      document.addEventListener('touchstart', _this.handleOutsideClick, false);
    });
    _defineProperty(_assertThisInitialized(_this), "removeClickListeners", function () {
      document.removeEventListener('click', _this.handleOutsideClick, false);
      document.removeEventListener('touchstart', _this.handleOutsideClick, false);
    });
    _defineProperty(_assertThisInitialized(_this), "openCalendar", function () {
      _this.setState({
        opened: true
      }, _this.addClickListeners);
    });
    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
      _this.setState({
        opened: false
      }, _this.removeClickListeners);
    });
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (date) {
      if (!isSameDay(_this.props.value, date)) {
        _this.props.onChange(date);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleClick", function () {
      return _this.props.onClick(_this.props.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      return _this.props.onFocus(_this.props.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      return _this.props.onBlur(_this.props.value);
    });
    _defineProperty(_assertThisInitialized(_this), "handleCalendarToggle", function () {
      var eventFn = _this.state.opened ? _this.props.onBlur : _this.props.onFocus;
      eventFn(_this.props.value);
      var rect = _this.node.getBoundingClientRect();
      _this.setState({
        top: window.pageYOffset + window.innerHeight - rect.bottom < 300
      });
      var calendarFn = _this.state.opened ? _this.closeCalendar : _this.openCalendar;
      calendarFn();
    });
    _defineProperty(_assertThisInitialized(_this), "handleCalendarChange", function (date) {
      if (_this.state.opened) {
        _this.props.onBlur(date);
      }
      _this.handleChange(date);
      _this.closeCalendar();
    });
    _defineProperty(_assertThisInitialized(_this), "handleOutsideClick", function (event) {
      if (!_this.node.contains(event.target)) {
        _this.props.onBlur(_this.props.value);
        _this.closeCalendar();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      if (event.charCode !== 13) {
        return;
      }
      _this.closeCalendar();
      _this.props.onEnterPress(_this.props.value);
      _this.props.onBlur(_this.props.value);
      event.target.blur();
    });
    _this.state = {
      opened: props.opened,
      top: false
    };
    _this.today = new Date();
    return _this;
  }
  _createClass(DatePickerStateless, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        value = _this$props.value,
        max = _this$props.max,
        min = _this$props.min,
        name = _this$props.name,
        disabled = _this$props.disabled,
        size = _this$props.size,
        status = _this$props.status,
        mask = _this$props.mask,
        className = _this$props.className,
        placeholder = _this$props.placeholder,
        hideNativeView = _this$props.hideNativeView;
      var _this$state = this.state,
        opened = _this$state.opened,
        top = _this$state.top;
      var showNativeView = isNative && !hideNativeView;
      var isCalendarOpened = !showNativeView && opened;
      var openedClassName = isCalendarOpened && "opened-".concat(top ? 'up' : 'down');
      return /*#__PURE__*/React.createElement("div", {
        className: cx(openedClassName, className, 'wrapper', {
          opened: isCalendarOpened
        }),
        onKeyPress: this.handleKeyPress,
        ref: function ref(node) {
          _this2.node = node;
        },
        role: "textbox",
        tabIndex: "0",
        "data-t-id": "components-DatePicker"
      }, /*#__PURE__*/React.createElement(DateInput, {
        className: cx('input'),
        disabled: disabled,
        hideNativeView: hideNativeView,
        mask: mask,
        max: max && new Date(max),
        min: min && new Date(min),
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        placeholder: placeholder,
        size: size,
        status: status,
        value: value
      }, /*#__PURE__*/React.createElement("button", {
        className: cx('button', "".concat(size, "_offset"), showNativeView && 'nativeButton'),
        disabled: disabled,
        onClick: this.handleCalendarToggle,
        title: "\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044C",
        type: "button",
        "data-t-id": "components-DatePicker"
      }, !showNativeView && /*#__PURE__*/React.createElement(CalendarIcon, null))), isCalendarOpened && /*#__PURE__*/React.createElement(Calendar, {
        className: cx('calendar'),
        max: max && new Date(max),
        min: min && new Date(min),
        onChange: this.handleCalendarChange,
        value: value || (min > this.today ? min : this.today)
      }));
    }
  }]);
  return DatePickerStateless;
}(Component);
_defineProperty(DatePickerStateless, "defaultProps", {
  value: new Date(),
  min: new Date('1900-01-01'),
  max: new Date('2099-12-31'),
  name: null,
  mask: '__.__.____',
  disabled: false,
  className: null,
  placeholder: 'дд.мм.гггг',
  onBlur: emptyCb,
  onChange: emptyCb,
  onClick: emptyCb,
  onFocus: emptyCb,
  onEnterPress: emptyCb,
  opened: false,
  size: 'default',
  status: null,
  hideNativeView: false
});
DatePickerStateless.propTypes = process.env.NODE_ENV !== "production" ? {
  value: PropTypes.instanceOf(Date),
  min: PropTypes.instanceOf(Date),
  max: PropTypes.instanceOf(Date),
  name: PropTypes.string,
  mask: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onEnterPress: PropTypes.func,
  opened: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'big']),
  status: PropTypes.string,
  hideNativeView: PropTypes.bool
} : {};
var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DatePicker, _React$PureComponent);
  var _super2 = _createSuper(DatePicker);
  function DatePicker(props) {
    var _this3;
    _classCallCheck(this, DatePicker);
    _this3 = _super2.call(this, props);
    _defineProperty(_assertThisInitialized(_this3), "handleChange", function (date) {
      return _this3.setState({
        date: date
      }, function () {
        return _this3.props.onChange(_this3.state.date);
      });
    });
    _defineProperty(_assertThisInitialized(_this3), "getValue", function () {
      return _this3.state.date;
    });
    _defineProperty(_assertThisInitialized(_this3), "render", function () {
      return /*#__PURE__*/React.createElement(DatePickerStateless, _extends({}, _this3.props, {
        onChange: _this3.handleChange,
        value: _this3.state.date
      }));
    });
    _this3.state = {
      date: props.value
    };
    return _this3;
  }
  return _createClass(DatePicker);
}(React.PureComponent);
_defineProperty(DatePicker, "defaultProps", DatePickerStateless.defaultProps);
export { DatePicker as default };
DatePicker.propTypes = process.env.NODE_ENV !== "production" ? DatePickerStateless.propTypes : {};